import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { MessageBubble } from "./MessageBubble";
import { ChatInput } from "./ChatInput";
import { RetryError } from "./RetryError";
import { ShareCard } from "./ShareCard";
import { useShareSnapshot } from "@/hooks/useShareSnapshot";

export const ChatSection = ({ decision, messages, isStreaming, error, onSend, onStop, onRetry }) => {
  const endRef = useRef(null);
  const { cardRef, target, share, isSharing } = useShareSnapshot();

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, error]);

  const shareExchange = (i) => {
    const prev = messages[i - 1];
    share({ decision, userText: prev?.role === "user" ? prev.text : "", alterText: messages[i].text });
  };

  return (
    <motion.section
      data-testid="chat-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex-1 flex flex-col min-h-0 relative z-10"
    >
      <div className="px-4 sm:px-6 py-3 border-b border-[#1E2333]">
        <p data-testid="decision-summary" className="max-w-3xl mx-auto font-mono text-xs text-[#94a3b8] tracking-wide truncate">
          <span className="text-[#a78bfa]">fork →</span> {decision}
        </p>
      </div>

      <div data-testid="message-list" className="flex-1 overflow-y-auto scrollbar-thin px-4 sm:px-6 py-6">
        <div className="max-w-3xl mx-auto flex flex-col gap-5">
          {messages.map((m, i) => (
            <MessageBubble
              key={i}
              role={m.role}
              text={m.text}
              stopped={m.stopped}
              streaming={isStreaming && i === messages.length - 1}
              onShare={m.role === "alter" ? () => shareExchange(i) : undefined}
              shareDisabled={isSharing}
            />
          ))}
          {error && <RetryError message={error} onRetry={onRetry} />}
          <div ref={endRef} />
        </div>
      </div>

      <ChatInput onSend={onSend} onStop={onStop} isStreaming={isStreaming} />

      {target && (
        <div aria-hidden style={{ position: "fixed", left: -20000, top: 0, pointerEvents: "none" }}>
          <ShareCard ref={cardRef} {...target} />
        </div>
      )}
    </motion.section>
  );
};
